import { Columns } from '@shared/interfaces/table/column-config';
import {ChargeInformationDto} from '@app/api/dmc';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import {StatusCellComponent} from '@shared/components/table/cells/status-cell/status-cell.component';

export const chargeinformationDetailsMasterdata: Columns<ChargeInformationDto>[] = [
  {
    title: 'chargeInformation.chargeType',
    key: 'chargeType',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'chargeInformation.chargeTypes.notspecified',
      subscription: 'chargeInformation.chargeTypes.subscription',
      fee: 'chargeInformation.chargeTypes.fee',
      tariff: 'chargeInformation.chargeTypes.tariff'
    }
  },
  {
    title: 'chargeInformation.chargeTypeId',
    key: 'chargeTypeId',
  },
  {
    title: 'chargeInformation.description',
    key: 'description'
  },
  {
    title: 'chargeInformation.longDescription',
    key: 'longDescription'
  },
  {
    title: 'chargeInformation.validFrom',
    key: 'validFrom',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'chargeInformation.detailsObservation',
    key: 'observationPeriod',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'chargeInformation.observationPeriods.notSpecified',
      hour: 'chargeInformation.observationPeriods.hour',
      quarter: 'chargeInformation.observationPeriods.quarter',
      day: 'chargeInformation.observationPeriods.day',
      month: 'chargeInformation.observationPeriods.month',
      year: 'chargeInformation.observationPeriods.year',
      other: 'chargeInformation.observationPeriods.other'
    }
  },
  {
    title: 'chargeInformation.vatClass',
    key: 'vatClass',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'chargeInformation.vatClassOptions.notspecified',
      novat: 'chargeInformation.vatClassOptions.novat',
      vat: 'chargeInformation.vatClassOptions.vat'
    }
  },
  {
    title: 'chargeInformation.transparentInvoicing',
    key: 'transparentInvoicing',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      false: 'common.no',
      true: 'common.yes',
    }
  },
  {
    title: 'chargeInformation.detailsValidTo',
    key: 'validTo',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'chargeInformation.dataHubStatus',
    key: 'dataHubStatus',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      confirmed: { color: 'bg-green-500', label: 'enum.datahub.status.confirmed' },
      pending: { color: 'bg-yellow-500', label: 'enum.datahub.status.pending' },
      pendingJob: { color: 'bg-yellow-500', label: 'enum.datahub.status.pendingJob' },
      rejected: { color: 'bg-red-500', label: 'enum.datahub.status.rejected' },
      obsolete: { color: 'bg-red-500', label: 'enum.datahub.status.obsolete' },
      notapplicable: { color: 'bg-gray-200', label: 'enum.datahub.status.notapplicable' },
      notspecified: { color: 'bg-gray-200', label: 'enum.datahub.status.notspecified' },
    }
  },
];
